import appTypes from './states/app';
const types = {
    appState: appTypes(),
};
export default types;
